module.exports = __webpack_public_path__ + "static/media/CircularXXWeb-Medium.0a6358ad.woff";